import { RootState } from '../../../../rootReducer';

export const licensedDevicesSelector = (state: RootState) => state.eventsLogModuleReducer.LicensedDevicesReducer;
